import React, { useState, useEffect } from 'react';
import 'react-quill/dist/quill.snow.css';
import Swal from 'sweetalert2';
import { formatPriceNew, KTSVG } from '../../../../../_metronic/helpers';
import {
  useGenerateOrderFromQuotation,
  useOrderByQuoId,
} from '../../hooks/QuotationHook';
import { dateFormatt } from '../../../../../_metronic/helpers/FormatDate';

type Props = {
  id: number;
  total: number;
};

const Orders: React.FC<Props> = ({ id, total }) => {
  const [reload, setReload] = useState(Math.random() * 40);

  const { list } = useOrderByQuoId(Number(id), reload);
  const { createOrderQuo, isSuccess } = useGenerateOrderFromQuotation();

  const addOrder = (id: number) => {
    Swal.fire({
      title: '¿Desea generar el pedido?',
      html: `
          <div className="text-gray-600">
            Si confirma esta acción creará el pedido del total de la cotización.
          </div>
          `,
      showCancelButton: true,
      padding: '2em',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-light me-3',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        createOrderQuo(id);
      }
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setReload(Math.random() * 40);
    }
  }, [isSuccess]);

  return (
    <>
      <div className="card mb-6 mb-xl-9">
        <div className="card-header">
          <div className="card-title m-0">
            <h3 className="fw-bolder m-0">Pedido</h3>
          </div>
        </div>
        <div className="card-body border-top p-9">
          <div className="row">
            <div className="table-responsive min-h-300px me-n5 pe-5 scroll-y">
              <table className="table table-border table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 me-n5 pe-5">
                <thead>
                  <tr className="text-gray-800 fs-7">
                    <th className="w-100px">Folio</th>
                    <th className="w-100px">Tipo</th>
                    <th className="w-200px">Nombre</th>
                    <th className="w-150px">Fecha de creación</th>
                    <th className="w-100px">Etapa</th>
                    <th className="w-100px">Estatus</th>
                    <th className="w-150px">Monto c/imp.</th>
                  </tr>
                </thead>
                <tbody className="">
                  {list.length > 0 ? (
                    list.map((row, index) => (
                      <tr key={row.id}>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600">
                              <>{row.folio}</>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600">
                              <>{row.tipo.name}</>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600">
                              <>{row.nombre}</>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600">
                              <>{dateFormatt(row.createdAt)}</>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600">
                              <>{row.etapa.name}</>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600">
                              <>{row.status.name}</>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column fs-012 fw-bold text-gray-600">
                              <>
                                {' '}
                                {`${formatPriceNew(
                                  row.monto_c_imp,
                                  'es-MX',
                                  'MXN',
                                  2,
                                  2
                                )}`}
                              </>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center text-muted">
                        Sin pedidos
                      </td>
                    </tr>
                  )}

                  {list.length <= 0 && (
                    <>
                      <tr>
                        <td colSpan={10}>
                          <div className="d-flex align-items-center">
                            <div
                              className="btn btn-light-primary btn-sm mb-10"
                              onClick={() => {
                                addOrder(id);
                              }}
                            >
                              <KTSVG
                                path="/media/icons/duotune/arrows/arr075.svg"
                                className="svg-icon-5"
                              />
                              Agregar
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;
